import { toClasses } from 'class-converter';
import CessionCapture from 'mpm-classes/CessionCapture';
import Components from 'mpm-components';
import * as Constans from 'mpm-config/Constants';
import Utilities from 'mpm-config/Utilities';
import Services from 'mpm-services';
import React from 'react';
import ListPage from './list';
import ViewPage from './view';

const searchCretariaInit = {
    numeroCessionComplet: "",
    typeCedant: "",
    numeroCedant: "",
    etat: "",
    dateCessionDu: "",
    dateCessionAu: "",
    numeroAgrement: "",
    menuCedant: false
};

export default (props) => {
    const [searchData, setSearchData] = React.useState(searchCretariaInit);
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState([]);
    const [pagination, setPagination] = React.useState({ page: Constans.DEFAULT_TABLE_PAGE, size: Constans.DEFAULT_TABLE_ROWS, totalPages: 1, });
    const [message, setMessage] = React.useState(null);
    const [pageVisibility, setPageVisibility] = React.useState({ showList: true, showForm: false, showView: false })
    const [selectedCessionCaptureId, setSelectedCessionCaptureId] = React.useState(null)

    const onReset = () => {
        setPagination({
            page: Constans.DEFAULT_TABLE_PAGE,
            size: Constans.DEFAULT_TABLE_ROWS,
            totalPages: 1,
        });
        setMessage(null);
        setSearchData(searchCretariaInit);
        setData([])
    };
    const loadData = (page) => {
        setLoading(true);
        let pagetoselect = page ? page - 1 : pagination.page - 1;
        Services.CessionsCaptureDataService.findAllPaginated(
            pagination.size,
            pagetoselect,
            searchData
        )
            .then((response) => {

                setData([]);
                setTimeout(() => {
                    setData(toClasses(response.data, CessionCapture))
                }, 100);
                setPagination({
                    page: response.page + 1,
                    size: response.size,
                    totalPages: response.totalPages,
                });
                setMessage({
                    info: true,
                    header: "Résultat de recherche",
                    content: `${response.total} occurence(s) trouvée(s) correspondante(s) à vos critères de recherche`,
                });
                setLoading(false);
            })
            .catch((err) => {
                setMessage({
                    error: true,
                    header: "Erreur lors de communication avec le serveur",
                    content: `Une erreur est survenue lors de communication avec le serveur. Veuillez réessayer ou contactez l'administrateur.`,
                });
                setLoading(false);
            })
            .finally();
    };

    const onUpdateSearch = (newSearch) => {
        setSearchData(newSearch)
    }

    const onSearch = () => {
        setMessage(null)
        loadData(pagination.page)
    }

    const onViewForm = (idForm) => {
        setMessage(null)
        setSelectedCessionCaptureId(idForm);
        setPageVisibility({ showForm: false, showList: false, showView: true })
    }

    const onComplet = (forceReload = false) => {
        setPageVisibility({ showForm: false, showList: true, showView: false });
        if (forceReload) {
            loadData(pagination.page)
        }
    }
    const onClickBreadCrumbItem = (item) =>{
        if(item === "Acquéreur"){
            setPageVisibility({ showForm: false, showList: true, showView: false });
        }
      }
    return (
        <>
            <Components.Regions.BreadCrumb
            onClickItem={(item) => onClickBreadCrumbItem(item)}
                data={Utilities.getBreadCrumbData(["Cession de Capture", "Acquéreur"],
                    false,
                    pageVisibility.showView && "Consultation",
                    pageVisibility.showList && "Recherche")} size="tiny" />
            {message && <Components.Message {...message} onClose={() => setMessage(null)} />}
            {
                pageVisibility.showList && <ListPage data={data} loading={loading} searchData={searchData} pagination={pagination}
                    onPageChange={(activePage) => loadData(activePage)}
                    onClickView={(id) => onViewForm(id)}
                    onClickReset={() => onReset()}
                    onClickSearch={() => onSearch()}
                    updateSearchData={(data) => onUpdateSearch(data)}
                />
            }

            {
                pageVisibility.showView && <ViewPage   onComplet={(forcer) => onComplet(forcer)} 
                setMessage={setMessage} 
                selectedCessionCaptureId={selectedCessionCaptureId} />
                
            }
        </>

    )
}
